export default "__VITE_ASSET__CsylTdQ$__"